namespace $ {

	export class $shm_hitalama_map_widget_entity_custom extends $giper_baza_entity.with({

		Class_name: $giper_baza_atom_text,
		// Class_base: $giper_baza_atom_text,
		Code_view_tree: $giper_baza_text,
		Code_css: $giper_baza_text,
		Code_js: $giper_baza_text,

		Visible_in_contextmenu: $giper_baza_atom_bool,

	}) {

		@ $mol_mem
		class_name() {
			return this.Code_view_tree()?.value().split(' ', 1)[0]
		}

	}

}
